module.exports = __webpack_public_path__ + "img/2.e55845a3.png";